import { api } from '@/shared/axios-client';

export type ScanSessionResponse = {
  success: boolean;
  data?: {
    scanId?: string;
    message?: string;
    graphGeneration?: boolean;
    skipped?: boolean;
  };
};

export const registerTestIntelligenceScanSession = (
  scanId: string,
): Promise<ScanSessionResponse> =>
  api.post('/api/test-intelligence/scan-session', {
    scanId: scanId.trim(),
  });
